module.exports = __webpack_public_path__ + "static/media/fresh-rose.14722f11.png";